import {translate} from "vue-gettext";

const {gettext: $gettext, pgettext: $pgettext} = translate;

export default {
    pending: 'pending',
    requested: 'requested',
    paid: 'paid',
    all: 'all',

    default() {
        return this.pending
    },

    label(status) {
        const labels = {
            [this.requested]: $pgettext('payout.status', 'Requested'),
            [this.pending]: $pgettext('payout.status', 'Pending Payment'),
            [this.paid]: $pgettext('payout.status', 'Paid'),
            [this.all]: $pgettext('payout.status', 'All')
        }
        return labels[status] || status
    },

    color(status) {
        const colors = {
            [this.requested]: 'warning',
            [this.pending]: 'info',
            [this.paid]: 'success'
        }
        return colors[status] || 'light'
    },

    icon(status) {
        const icons = {
            [this.pending]: 'cipClock',
            [this.requested]: 'cipDotOrange',
            [this.paid]: 'cipDotGreen'
        }
        return icons[status] || 'cipDot'
    },

    options(includeAll = false) {
        const opts = [
            {
                value: this.pending,
                label: $pgettext('payout.status', 'Pending')
            },
            {
                value: this.requested,
                label: $pgettext('payout.status', 'Requested')
            },
            {
                value: this.paid,
                label: $pgettext('payout.status', 'Paid')
            }
        ]
        
        if (includeAll) {
            opts.unshift({
                value: this.all,
                label: $pgettext('payout.status', 'All')
            })
        }
        
        return opts
    },
    
    getSelectOptions(context = 'admin-payout', includeAll = true) {
        // Returns options formatted for CSelect with custom translation context
        // This allows each component to use its own translation context
        const opts = [
            { value: this.pending, label: $pgettext(context, 'Pending') },
            { value: this.requested, label: $pgettext(context, 'Requested') },
            { value: this.paid, label: $pgettext(context, 'Paid') }
        ]
        
        if (includeAll) {
            opts.unshift({
                value: this.all,
                label: $pgettext(context, 'All')
            })
        }
        
        return opts
    },

    values() {
        return [this.pending, this.requested, this.paid]
    }
}